var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPcSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_pc_small",
    transform: "translate(-700 -201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2932",
    "data-name": "Rectangle 2932",
    width: 24,
    height: 24,
    transform: "translate(700 201)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M4451,338a1,1,0,0,1,0-2h2.268a1.987,1.987,0,0,1-.268-1h-3a3,3,0,0,1-3-3v-7a3,3,0,0,1,3-3h12a3,3,0,0,1,3,3v7a3,3,0,0,1-3,3h-3a1.992,1.992,0,0,1-.268,1H4461a1,1,0,1,1,0,2Zm-2-13v7a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1v-7a1,1,0,0,0-1-1h-12A1,1,0,0,0,4449,325Z",
    transform: "translate(-3744 -117)",
    fill: "#596ffe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPcSmall);
export default __webpack_public_path__ + "static/media/icon_pc_small.8ab5212b.svg";
export { ForwardRef as ReactComponent };